import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
type Purchase = {
  name: string;
  country: string;
  flag: string;
};
const PURCHASES: Purchase[] = [{
  name: 'Dra. Valentina R.',
  country: 'Colombia',
  flag: '🇨🇴'
}, {
  name: 'Dr. Andrés M.',
  country: 'México',
  flag: '🇲🇽'
}, {
  name: 'Dra. Lucía F.',
  country: 'Argentina',
  flag: '🇦🇷'
}, {
  name: 'Dr. Javier S.',
  country: 'España',
  flag: '🇪🇸'
}, {
  name: 'Dra. Camila T.',
  country: 'Chile',
  flag: '🇨🇱'
}, {
  name: 'Dr. Fernando O.',
  country: 'Perú',
  flag: '🇵🇪'
}, {
  name: 'Dra. Gabriela N.',
  country: 'Ecuador',
  flag: '🇪🇨'
}, {
  name: 'Dr. Ricardo B.',
  country: 'Uruguay',
  flag: '🇺🇾'
}, {
  name: 'Dra. Paola C.',
  country: 'Costa Rica',
  flag: '🇨🇷'
}, {
  name: 'Dr. Miguel Á.',
  country: 'Guatemala',
  flag: '🇬🇹'
}, {
  name: 'Dra. Daniela E.',
  country: 'Panamá',
  flag: '🇵🇦'
}, {
  name: 'Dr. Hugo L.',
  country: 'República Dominicana',
  flag: '🇩🇴'
}];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let showTimer: number;
    let hideTimer: number;
    const cycle = () => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % PURCHASES.length);
        showTimer = window.setTimeout(cycle, 9000);
      }, 6000);
    };
    showTimer = window.setTimeout(cycle, 6000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, []);
  const purchase = PURCHASES[index];
  return <AnimatePresence data-id="element-185" data-mp="x2y827dh5oio">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.32,
      ease: 'easeOut'
    }} role="status" aria-live="polite" className="fixed bottom-24 left-3 right-3 z-30 mx-auto max-w-xs sm:left-4 sm:right-auto sm:bottom-28" data-id="element-186" data-mp="s5ybqo6fg04r">
          <div className="flex items-start gap-3 rounded-2xl border border-navy-100 bg-white p-3 shadow-xl shadow-navy/10" data-id="element-187" data-mp="2fmcxb9r3m28i">
            <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-green-50" data-id="element-188" data-mp="2knip95cxplgz">
              <CheckCircle2Icon className="h-5 w-5 text-green-600" aria-hidden="true" data-id="element-189" data-mp="2pjhm7hcbwbt0" />
            </div>
            <div className="min-w-0" data-id="element-190" data-mp="1rw8uv5pnc8j3">
              <p className="text-[13px] font-bold leading-snug text-navy-800" data-id="element-191" data-mp="1wwdev5prjle2">
                {purchase.name} <span className="font-medium" data-id="element-192" data-mp="21vzol56duji4">acaba de comprar</span>
              </p>
              <p className="truncate text-[12px] font-medium text-navy/60" data-id="element-193" data-mp="26nhr3xo20s57">
                Kit Clínico para el Manejo de la Obesidad
              </p>
              <p className="mt-0.5 text-[11px] text-navy/45" data-id="element-194" data-mp="197bzeyiij9za">
                {purchase.flag} {purchase.country} · hace unos minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}